import SearchableSelector from "@/components/ui/others/SearchableSelector";

interface FilterOption {
  value: string;
  label: string;
}

interface FilterDropdownProps {
  value: string;
  onValueChange: (value: string) => void;
  options: FilterOption[];
  placeholder?: string;
  searchInputPlaceholder?: string;
  "aria-labelledby"?: string;
}

export default function FilterDropdown({
  value,
  onValueChange,
  options,
  placeholder = "Select...",
  searchInputPlaceholder,
  "aria-labelledby": ariaLabelledBy,
}: FilterDropdownProps) {
  const fallback =
    options.find((o) => o.value === "all")?.label ?? placeholder;

  return (
    <SearchableSelector
      value={value}
      onChange={onValueChange}
      placeholder={fallback}
      searchInputPlaceholder={searchInputPlaceholder ?? "Search options…"}
      options={options.map((option) => ({
        value: option.value,
        name: option.label,
      }))}
      aria-labelledby={ariaLabelledBy}
      triggerClassName="min-h-10 w-full border-[var(--color-green-4)] px-3 py-2 rounded-[12px] shadow-none hover:bg-white text-[14px] font-medium text-[var(--color-black-9)] tracking-[-0.56px] leading-normal"
    />
  );
}
